export default "__VITE_ASSET__C7KcMX_m__"